//@flow
import React from 'react';
import formStyles from './styles/FormGeneral.scss';

type Props = {|
    header: string,
    subheader: string,
    page: 'page1' | 'page2',
    button?: element,
    classNames: string,
|};

export const Banner = (props: Props) => {
    let previousPageClass;
    let nextPageClass;
    if (props.page === 'page1') {
        previousPageClass = formStyles.activePage;
        nextPageClass = formStyles.inactivePage;
    } else {
        previousPageClass = formStyles.inactivePage;
        nextPageClass = formStyles.activePage;
    }
    return (
        <div className={formStyles.item}>
            <div className={formStyles.bannerDiv} id="jsScrollTargetHeader">
                <div className={formStyles.bannerHeader}>
                    {props.header}
                    <div className={formStyles.pageIndicator}>
                        <div className={previousPageClass} />
                        <div className={nextPageClass} />
                    </div>
                </div>
                <div className={props.classNames}>{props.subheader}</div>
                {props.button}
            </div>
        </div>
    );
};
